<script setup>
import { ref } from 'vue'

import OriginalThemeProvider from '../../OriginalThemeProvider.vue'
import ActionButton from '../src/index.vue'
import { extActionButtonProps } from '../src/props'

const props = defineProps({
  ...extActionButtonProps,
  upload: {
    type: Function,
    default: undefined
  },
  imageTabs: {
    type: Array,
    default: () => []
  },
  hiddenTabs: {
    type: Array,
    default: () => []
  }
})

const model = ref({})

function onAction() {
  const selection = props.editor && props.editor.view && props.editor.view.state && props.editor.view.state.selection
  const attrs = (selection && selection.node && selection.node.attrs) ? selection.node.attrs : {}

  if (attrs && attrs.src) model.value.src = attrs.src
  if (attrs && attrs.alt) model.value.alt = attrs.alt
  if (attrs && attrs.title) model.value.title = attrs.title
  if (attrs && attrs.width !== undefined) model.value.width = attrs.width
  if (attrs && attrs.height !== undefined) model.value.height = attrs.height
  if (attrs && attrs.display) model.value.display = attrs.display
  model.value.lockAspectRatio = (attrs && Object.prototype.hasOwnProperty.call(attrs, 'lockAspectRatio'))
    ? !!attrs.lockAspectRatio
    : true
}
</script>

<template>
  <ActionButton
    :editor="editor"
    :action="onAction"
    :is-active="() => editor.isActive('image') || false"
    :disabled="!editor.can().setImage({})"
    :tooltip="t('editor.image.tooltip')"
    icon="image"
  >
    <OriginalThemeProvider>
      <slot name="dialog" :props="{ editor, value: model, imageTabs, hiddenTabs, upload }"></slot>
    </OriginalThemeProvider>
  </ActionButton>
</template>